exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FilterItem-module__filter-item___nqHr0{background:#787878;color:#fff;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;width:140px;padding:4px;text-transform:capitalize;cursor:pointer;border:1px solid #787878;display:flex;flex-direction:column;align-items:center;border-bottom-left-radius:6px;border-bottom-right-radius:6px}.FilterItem-module__filter-item___nqHr0.FilterItem-module__active___K1NAg{background-color:#fff;color:#787878;border:1px solid #787878}", ""]);

// exports
exports.locals = {
	"filter-item": "FilterItem-module__filter-item___nqHr0",
	"active": "FilterItem-module__active___K1NAg"
};